import { FC, useContext, useState } from 'react';

// Components
import { FacebookIcon, InstagramIcon, TwitterIcon, WebIcon, YouTubeIcon, ConfigContext, TooltipV2 } from '@velinsi/smp-widgets-ui';

// Utils
import { classNames, getLabelValue } from '@sportal365/smp-widget-utils';

// Types
import { Theme } from '../../../../../../packages/tailwind/types';

interface Props {
  href: string;
  social: string;
}

const getSocial = (social: string, dataLabels?: Record<string, string | undefined> | null) => {
  switch (social) {
    case 'web':
      return { icon: <WebIcon />, text: getLabelValue(dataLabels?.web, 'Official website') };
    case 'instagram':
      return { icon: <InstagramIcon />, text: getLabelValue(dataLabels?.instagram, 'Instagram page') };
    case 'facebook':
      return { icon: <FacebookIcon />, text: getLabelValue(dataLabels?.facebook, 'Facebook page') };
    case 'twitter':
      return { icon: <TwitterIcon />, text: getLabelValue(dataLabels?.twitter, 'Twitter page') };
    case 'youtube':
      return { icon: <YouTubeIcon />, text: getLabelValue(dataLabels?.youtube, 'Youtube channel') };
  }
};

export const SocialIcon: FC<Props> = ({ href, social }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => setShow(true);
  const handleMouseLeave = () => setShow(false);

  const { dataTheme, dataLabels } = useContext(ConfigContext);
  const data = getSocial(social, dataLabels);

  if (!data) return null;

  return (
    <div className='social-icon-container relative' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <a
        href={href}
        target='_blank'
        rel='noreferrer'
        className={classNames({
          'w-7 h-7 flex items-center justify-center rounded-6 bg-socialIconBgColor hover:bg-hiContrast ': true,
          'text-socialIconColor hover:text-black': dataTheme === Theme.dark,
          'text-socialIconColor hover:text-white': dataTheme === Theme.light,
        })}
      >
        {data.icon}
      </a>
      {show && (
        <TooltipV2 showTooltip={show}>
          <span className='text-standingsTooltipContainerTextColor'>{data.text}</span>
        </TooltipV2>
      )}
    </div>
  );
};
